import { NotificationType } from '@breakroom-nx/helpers';

export interface NotificationAction {
  label: string;
  actionType: string; // e.g., 'accept', 'decline', 'view', etc.
  payload?: any;
}

export class Notification {
  uid: string = '';
  type: NotificationType = NotificationType.System;
  title: string = '';
  message: string = '';
  read: boolean = false;
  createdAt: Date = new Date();
  updatedAt?: Date;
  actions?: NotificationAction[] = [];

  // Optional fields for app-specific use
  notificationCreator?: string;
  roomBeingInvitedTo?: string;

  public constructor(init?: Partial<Notification>) {
    Object.assign(this, init);
  }
}

// Firestore Data Converter
export const notificationConverter = {
  toFirestore: (notification: Notification) => {
    return {
      type: notification.type,
      title: notification.title,
      message: notification.message,
      read: notification.read,
      createdAt: notification.createdAt,
      updatedAt: notification.updatedAt ?? null,
      actions: notification.actions ?? [],
      notificationCreator: notification.notificationCreator,
      roomBeingInvitedTo: notification.roomBeingInvitedTo,
    };
  },
  fromFirestore: (snap: any) => {
    const data: any = snap.data();
    const notificationID = snap.id;
    return new Notification({
      uid: notificationID,
      type: data.type,
      title: data.title,
      message: data.message,
      read: data.read ?? false,
      createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : new Date(),
      updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : undefined,
      actions: data.actions ?? [],
      notificationCreator: data.notificationCreator,
      roomBeingInvitedTo: data.roomBeingInvitedTo,
    });
  },
};
